var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"20px"}},[_vm._v("\n    An error occured.\n    "),_c('router-link',{attrs:{"to":"/"}},[_vm._v("\n        Back to homepage\n    ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }